import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import Team from "@mapmycustomers/shared/types/Team";
import User from "@mapmycustomers/shared/types/User";

import RoleFilter from "../../components/PermissionsReport/enum/RoleFilter";

export const initializePermissionsReport = createAsyncAction(
  "reports/permissionsReport/initialize/request",
  "reports/permissionsReport/initialize/success",
  "reports/permissionsReport/initialize/failure"
)<void, User[], unknown>();

export const downloadPermissionsReportCsv = createAction(
  "reports/permissionsReport/downloadCsv"
)<void>();

export const setPermissionsReportRoleFilter = createAction(
  "reports/permissionsReport/setRoleFilter"
)<RoleFilter>();

export const setPermissionsReportSearchQuery = createAction(
  "reports/permissionsReport/setSearchQuery"
)<string>();

export const setPermissionsReportTeamId = createAction("reports/permissionsReport/setTeamId")<
  Team["id"] | undefined
>();

export type PermissionsReportActions = ActionType<
  | typeof downloadPermissionsReportCsv
  | typeof initializePermissionsReport
  | typeof setPermissionsReportRoleFilter
  | typeof setPermissionsReportSearchQuery
  | typeof setPermissionsReportTeamId
>;
